import { Controller } from "stimulus"
import {DataTable} from "simple-datatables"

export default class extends Controller {

  initialize() {
    this.dataTable = new DataTable("#teamMemberListTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No team members found",
        info: "Showing {start} to {end} of {rows} team members"
      }
    });
    //this.ourSearchBar = document.getElementById('teamMemberSearchBar');
    this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    //this.setupDataTableSearch();
    this.addDeleteModalEventListener();
    this.addActivateModalEventListener();
    this.addSortButtonLabels();
    this.addPaginationLabels();
  }

  addSortButtonLabels() {
    //for screenreaders to announce the sort column
    let sortLinks = document.querySelectorAll('.dataTable-sorter');
    sortLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Sort column ${index + 1}`);
    });
  }

  addPaginationLabels() {
    //for screenreaders to announce the page number in the table
    let paginationLinks = document.querySelectorAll('.dataTable-pagination a');
    paginationLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Go to page ${index + 1}`);
    });
  }

  addDeleteModalEventListener() {
    let deleteTeamMemberModal = document.getElementById('deleteTeamMemberModal');
    deleteTeamMemberModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let teamMemberDatata = button.getAttribute('data-bs-delete-team-member')
      let data = JSON.parse(teamMemberDatata);
      document.getElementById('deleteTeamMemberHeader').innerHTML = 'Delete ' + data.name + '?'
      document.getElementById('deleteTeamMemberForm').action = 'team/' + data.id.toString();
      document.getElementById('confirmDelete').focus();
    })
  }


  addActivateModalEventListener() {
    let activateTeamMemberModal = document.getElementById('activateTeamMemberModal');
    activateTeamMemberModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let teamMemberDatata = button.getAttribute('data-bs-activate-team-member')
      let data = JSON.parse(teamMemberDatata);
      document.getElementById('activateTeamMemberHeader').innerHTML = 'Activate ' + data.name + '?'
      document.getElementById('activateTeamMemberForm').action = 'team/' + data.id.toString();
      document.getElementById('confirmActivate').focus();
    })
  }

  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }

}